<template>
  <Drawer :direction="drawerDirection" :open="open" @update:open="handleOpenChange">
    <DrawerContent :class="contentClass" :position="drawerDirection">
      <div class="relative flex min-h-0 flex-1 flex-col overflow-hidden">
        <img alt="" aria-label="ドロワーを閉じる" class="absolute right-0 top-0 z-10 h-10 w-10 cursor-pointer p-2 md:right-8" role="button" src="@/assets/icon/close/black.svg" @click="handleClose" />
        <div class="drawer-content-area min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 pb-4 pt-10 md:px-8 md:pb-8 md:pt-14">
          <h2 v-if="content?.title" class="pb-4 text-xl text-light-fg-emphasis">{{ content.title }}</h2>
          <div class="drawer-rich-text-wrapper min-w-0 break-words">
            <StyledRichText v-if="content?.contents" :html="content.contents" />
          </div>
        </div>
      </div>
    </DrawerContent>
  </Drawer>
</template>

<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core';

import { Drawer, DrawerContent } from '@/components/lib/shadcn-vue/drawer';
import { StyledRichText } from '@/wabunka-src/common/features/Featured/components/StyledRichText';
import type { DrawerContentItem } from '@/wabunka-src/common/features/Featured/models/featured/featured';

interface Props {
  open: boolean;
  content: DrawerContentItem | null;
  onOpenChange?: (open: boolean) => void;
}

const props = defineProps<Props>();

const handleOpenChange = (open: boolean) => {
  props.onOpenChange?.(open);
};

const handleClose = () => handleOpenChange(false);

const isDesktop = useMediaQuery('(min-width: 768px)');
const drawerDirection = computed<'bottom' | 'right'>(() => (isDesktop.value ? 'right' : 'bottom'));

const contentClass = computed(() => `rich-text-content-drawer-panel ${isDesktop.value ? '!z-[1001] h-full w-[600px] bg-white font-Spectral' : '!z-[1001] max-h-[85dvh] bg-white font-Spectral'}`);
</script>

<style scoped>
.drawer-rich-text-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* テーブルがはみ出さないよう、全幅でセル内改行（Mobile/Desktop 共通） */
.drawer-content-area :deep(table) {
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
}

.drawer-content-area :deep(table th),
.drawer-content-area :deep(table td) {
  min-width: 0 !important;
  width: 1% !important; /* 列を可変にして改行を許容（table-layout: fixed で均等配分） */
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.drawer-content-area :deep(img) {
  max-width: 100%;
  height: auto;
}
</style>

<style>
[data-vaul-drawer-wrapper] [data-vaul-overlay] {
  z-index: 1000 !important;
}

[data-vaul-drawer] {
  z-index: 1001 !important;
}

/* 初期表示時にドロワー全体にフォーカスが当たり青枠が出るのを防ぐ */
[data-vaul-drawer].rich-text-content-drawer-panel:focus {
  outline: none;
}
</style>
